import React, { useContext, useEffect, useState } from 'react';
import {
  Card,
  Button,
  Typography,
  Spin,
  Alert,
  message,
  Tabs,
  Avatar,
  Popover,
  Pagination,
  Descriptions,
  Modal,
  Tag,
  Radio,
  Space,
  Tooltip
} from 'antd';
import {
  ArrowLeftOutlined,
  PlayCircleOutlined,
  ClockCircleOutlined,
  BookOutlined,
  StarOutlined,
  UserOutlined,
  LinkedinOutlined,
  TeamOutlined,
  StarFilled
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import useAvailableCourses from 'PlatForms/SelfLMS/Hooks/Courses/useCourses';
import useEnrolledCourses from 'PlatForms/SelfLMS/Hooks/Courses/useEnrolledCourses';
import { selfLearnerService } from 'PlatForms/SelfLMS/Services/Courses/CourseService';
import { ProfileContext } from 'Common/hooks/context/ProfileContext';
import { toast } from 'react-toastify';

import { 
  ExpertRecommendationLevelEnum, 
  ExpertRecommendationLevelEnumLabels 
} from 'Common/Constants/Enums/ExpertRecommendation';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const AvailableCourses = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Use the hooks with pagination
  const {
    courses,
    loading: coursesLoading,
    error: coursesError,
    enrollingId,
    enrollInCourse,
    pagination: availablePagination,
    handlePageChange: handleAvailablePageChange,
    handlePageSizeChange: handleAvailablePageSizeChange,
    refetch: refetchAvailableCourses
  } = useAvailableCourses();

  const {
    enrollments,
    loading: enrollmentsLoading,
    error: enrollmentsError,
    pagination: enrolledPagination,
    handlePageChange: handleEnrolledPageChange,
    handlePageSizeChange: handleEnrolledPageSizeChange,
    refetch: refetchEnrolledCourses
  } = useEnrolledCourses();

  console.log("........................enrollments",enrollments);
  const [startingCourse, setStartingCourse] = useState(null);
  const [localEnrollingId, setLocalEnrollingId] = useState(null);
  const [activeTab, setActiveTab] = useState('available');
  const [expandedCourseId, setExpandedCourseId] = useState(null);
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;

  // Price Modal State
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPriceData, setSelectedPriceData] = useState(null);

const [isExpertSupportModalVisible, setIsExpertSupportModalVisible] = useState(false);
const [selectedCourseForPurchase, setSelectedCourseForPurchase] = useState(null);
const [includeExpertSupport, setIncludeExpertSupport] = useState(false);


  useEffect(() => {
    if (location.state?.courseBlocked) {
      message.error("This course has been blocked due to failed assessment attempts. Please contact your mentor.");
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const openPriceModal = (e, course) => {
    e.stopPropagation(); // Prevents navigating to course details
    setSelectedPriceData(course);
    setIsModalVisible(true);
  };

  // Logic to convert days to readable Y/M/D
  const formatDuration = (totalDays) => {
    if (!totalDays) return "Not specified";
    const years = Math.floor(totalDays / 365);
    const months = Math.floor((totalDays % 365) / 30);
    const days = (totalDays % 365) % 30;

    const parts = [];
    if (years > 0) parts.push(`${years} ${years === 1 ? 'Year' : 'Years'}`);
    if (months > 0) parts.push(`${months} ${months === 1 ? 'Month' : 'Months'}`);
    if (days > 0) parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`);
    return parts.join(", ");
  };

  const formatTime = (timeString) => {
    if (!timeString || timeString === "00:00:00") return "Not specified";

    const [hours, minutes] = timeString.split(":");
    const hoursInt = parseInt(hours);
    const minutesInt = parseInt(minutes);

    if (hoursInt === 0 && minutesInt === 0) return "Not specified";
    if (hoursInt === 0) return `${minutesInt}m`;
    if (minutesInt === 0) return `${hoursInt}h`;

    return `${hoursInt}h ${minutesInt}m`;
  };

const formatMinutesToHours = (minutes) => {
  if (!minutes || minutes <= 0) return "Not specified";

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours > 0 && remainingMinutes > 0) {
    return `${hours}h${remainingMinutes}m`;
  }

  if (hours > 0) {
    return `${hours}h`;
  }

  return `${remainingMinutes}m`;
};


  // Helper function to get author name
  const getAuthorName = (course) => {
    if (course.courseAuthor && course.courseAuthor.name) {
      return course.courseAuthor.name;
    }
    if (course.authorName) {
      return course.authorName;
    }
    return "Unknown Author";
  };

  // Helper function to get LinkedIn URL
  const getLinkedInUrl = (course) => {
    if (course.courseAuthor && course.courseAuthor.linkedinUrl) {
      return course.courseAuthor.linkedinUrl;
    }
    if (course.linkedinUrl) {
      return course.linkedinUrl;
    }
    if (course.authorLinkedIn) {
      return course.authorLinkedIn;
    }
    return null;
  };

 

const showExpertSupportModal = (course) => {
  setSelectedCourseForPurchase(course);

  const isRequired =
    course.courseExpertSupport?.recommendationLevel ===
    ExpertRecommendationLevelEnum.Required;

  setIncludeExpertSupport(isRequired ? true : false);
  setIsExpertSupportModalVisible(true);
};


  const handleContinueLearning = async (enrollmentId) => {
    if (isBlocked) {
      message.warning("Please complete your profile first");
      return;
    }

    try {
      setStartingCourse(enrollmentId);

      const response = await selfLearnerService.startCourseEnrollment(enrollmentId);

      console.log('API response: in continue learning button .....', response);

      if (response.isAssessmentPage) {
        navigate(`/selfLearner-dashboard/enrolled-courses/${enrollmentId}/modules/${response.moduleProgressId}/assessment`, {
          state: {
            moduleId: response.moduleId,
            assessmentId: response.assessmentPage.id,
            moduleProgressId: response.moduleProgressId,
            enrollmentId: enrollmentId,
            assessmentTitle: response.assessmentPage.title,
            assessmentData: response
          }
        });
      } else {
        let pageId;

        if (response.currentPageId) {
          pageId = response.currentPageId;
        } else if (response.hasPrevious && response.previousPageId) {
          pageId = response.previousPageId;
        } else if (response.hasNext && response.nextPageId) {
          pageId = response.nextPageId;
        } else {
          pageId = response.moduleId;
          console.warn("No specific page ID found, using module ID as fallback");
        }

        navigate(`/selfLearner-dashboard/enrolled-courses/${enrollmentId}/modules/${response.moduleProgressId}/pages/${pageId}`, {
          state: {
            moduleId: response.moduleId
          }
        });
      }

    } catch (error) {
      console.error('Error starting course:', error);
      message.error('Failed to start course. Please try again.');
    } finally {
      setStartingCourse(null);
    }
  };

  
const handleEnroll = async (course, e) => {
  e?.stopPropagation();

  if (isBlocked) {
    message.warning("Please complete your profile first");
    return;
  }

  try {
    setLocalEnrollingId(course.id);
    
    // FREE COURSE FLOW
    if (!course.isPaid) {
      const enrollmentResponse = await enrollInCourse(course.id);
      toast.success(`Successfully enrolled in "${course.title}"`);
      await refetchAvailableCourses();
      await refetchEnrolledCourses();
      setActiveTab("enrolled");
      return;
    }

    console.log("Course details before check:", {
      id: course.id,
      title: course.title,
      hasActiveExpertSupport: course.hasActiveExpertSupport,
      hasCourseExpertSupport: !!course.courseExpertSupport
    });
     console.log("selected course for ",selectedCourseForPurchase);

    // PAID COURSE FLOW - Check for expert support
    if (course.hasActiveExpertSupport) {
      // First, fetch full course details to get expert support info
      try {
        console.log("Fetching course details for expert support...");
        const fullCourseDetails = await selfLearnerService.getCourseDetails(course.id);
        console.log("Full course details:", fullCourseDetails);
        
        if (fullCourseDetails.courseExpertSupport) {
          // Merge the expert support data with the course
          const courseWithExpertSupport = {
            ...course,
            courseExpertSupport: fullCourseDetails.courseExpertSupport
          };
          showExpertSupportModal(courseWithExpertSupport);
        } else {
      
          console.log("No expert support found in course details");
          proceedWithPurchase(course.id, false);
        }
      } catch (error) {
        console.error("Error fetching course details:", error);
        
        proceedWithPurchase(course.id, false);
      }
      return;
    }

    // REGULAR PAID COURSE WITHOUT EXPERT SUPPORT
    proceedWithPurchase(course.id, false);
    
  } catch (error) {
    console.error("Enrollment / Payment failed:", error);
    toast.error(
      error.response?.data?.details ||
      "Something went wrong. Please try again."
    );
  } finally {
    setLocalEnrollingId(null);
  }
};


const proceedWithPurchase = async (courseId, includeSupport) => {
  try {

    console.log("...................Purchasing with:", {
  courseId,
  includeSupport
});
  
  const addOnExpertSupport = includeSupport;
    const purchaseResponse = await selfLearnerService.requestCoursePurchase(
      courseId, 
      addOnExpertSupport
    );

    console.log("purchase response ", purchaseResponse);
    if (purchaseResponse?.sessionUrl) {
      window.location.href = purchaseResponse.sessionUrl;
    } else {
      toast.error("Unable to initiate payment. Please try again.");
    }
  } catch (error) {
    console.error("Purchase failed:", error);
    toast.error(error.response?.data?.message || "Payment failed");
  }
};


  const handleViewCourse = (courseId) => {
    if (isBlocked) {
      message.warning("Please complete your profile first");
      return;
    }

    navigate(`/selfLearner-dashboard/available-courses/courses/${courseId}`);
  };

  const handleViewEnrolledCourse = (enrollmentId) => {
    if (isBlocked) {
      message.warning("Please complete your profile first");
      return;
    }
 console.log("ejdksalj;ldfa",enrollmentId);
    navigate(`/selfLearner-dashboard/enrolled-courses/courses/${enrollmentId}`);
  };

  const handleBack = () => {
    navigate("/selfLearner-dashboard");
  };

  const handleTabChange = (key) => {
    if (isBlocked) {
      message.warning("Please complete your profile first");
      return;
    }

    setActiveTab(key);
  };

  const toggleDescription = (courseId, e) => {
    e.stopPropagation();
    setExpandedCourseId(expandedCourseId === courseId ? null : courseId);
  };

  
  const handleAvailablePaginationChange = (page, size) => {
    if (size !== availablePagination.pageSize) {
      handleAvailablePageSizeChange(size);
    } else {
      handleAvailablePageChange(page);
    }
  };
  
  const handleEnrolledPaginationChange = (page, size) => {
    if (size !== enrolledPagination.pageSize) {
      
      handleEnrolledPageSizeChange(size);
    } else {
      
      handleEnrolledPageChange(page);
    }
  };

  
  const calculateProgress = (enrollment) => {
    if (enrollment.isCompleted) return 100;
    if (enrollment.moduleCount === 0) return 0;
    return Math.round(((enrollment.completedModuleCount || 0) / enrollment.moduleCount) * 100);
  };

  const loading = coursesLoading || enrollmentsLoading;
  const error = coursesError || enrollmentsError;

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error Loading Courses"
        description={error}
        type="error"
        showIcon
        style={{ margin: "20px" }}
        action={
          <Button size="small" onClick={handleBack}>
            Go Back
          </Button>
        }
      />
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f7fafc'
    }}>
      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '20px'
      }}>
        {/* Show incomplete profile alert if profile is not complete */}
        {isBlocked && (
          <Alert
            message="Complete Your Profile"
            description="Please complete your profile to access courses."
            type="warning"
            showIcon
            style={{ marginBottom: '20px' }}
            action={
              <Button
                size="small"
                type="primary"
                onClick={() => navigate("/selfLearner-profile")}
              >
                Complete Profile
              </Button>
            }
            closable
          />
        )}

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <div style={{ textAlign: 'left' }}>
            <Title level={1} style={{ color: '#2d3748', marginBottom: '8px', margin: 0 }}>
              Courses
            </Title>
            <Text type="secondary" style={{ fontSize: '16px' }}>
              Manage your learning journey
            </Text>
          </div>

          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            onClick={handleBack}
          >
            Back to Dashboard
          </Button>
        </div>

        {/* Tabs Section */}
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          style={{ marginBottom: '24px' }}
          size="large"
        >
          {/* Available Courses Tab */}
          <TabPane
            tab={
              <span>
                <StarOutlined />
                Available Courses
                {availablePagination.totalCount > 0 && (
                  <span style={{
                    marginLeft: '8px',
                    backgroundColor: '#1890ff',
                    color: 'white',
                    borderRadius: '10px',
                    padding: '2px 8px',
                    fontSize: '12px'
                  }}>
                    {availablePagination.totalCount}
                  </span>
                )}
              </span>
            }
            key="available"
          >
            {courses.length > 0 ? (
              <>
                {courses.map((course) => {
                  const linkedInUrl = getLinkedInUrl(course);
                  const authorName = getAuthorName(course);

                  return (
                    <Card
                      key={course.id}
                      style={{
                        width: '100%',
                        marginBottom: '16px',
                        border: '3px solid #cdd6e2ff',
                        borderTop: 'none',
                        borderRadius: '0px',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                        cursor: isBlocked ? 'not-allowed' : 'pointer',
                        position: 'relative', // Essential for the absolute ribbon
                        overflow: 'hidden',   // Clips the ribbon edges
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                      hoverable={!isBlocked}
                      onClick={() => !isBlocked && handleViewCourse(course.id)}
                      bodyStyle={{
                        padding: '14px',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1
                      }}
                    >
                    
 

                      {/* --- CORNER RIBBON BANNER --- */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          openPriceModal && openPriceModal(e, course);
                        }}
                        style={{
                          position: "absolute",
                          // Adjusted offsets for a larger ribbon
                          top: 22,
                          right: -45,
                          background: course.isPaid ? "#13c2c2" : "#52c41a",
                          color: "white",
                          // Added more vertical padding and horizontal breath
                          padding: "6px 0",
                          transform: "rotate(45deg)",
                          fontSize: "13px", // Slightly larger font
                          fontWeight: "bold",
                          zIndex: 10,
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          textAlign: "center",
                          // Increased width to accommodate longer prices
                          width: "160px",
                          cursor: "pointer",
                          lineHeight: "1"
                        }}
                      >
                        {course.isPaid ? (
                          `${course.pricing?.currency === "USD" ? "$" : course.pricing?.currency}${course.pricing?.price || 0}`
                        ) : (
                          "FREE"
                        )}
                      </div>

                      {/* 1. Title Section (with padding right to avoid ribbon overlap) */}
                     <Title
  level={4}
  style={{
    margin: 0,
    marginBottom: '12px',
    lineHeight: "1.3",
    paddingRight: '40px',
    minHeight: '44px',
    fontSize: '16px'
  }}
>
  {course.title}
  
  {/* INLINE STAR + TEXT */}
  {course.hasActiveExpertSupport && (
    <span style={{ 
      marginLeft: '8px', 
      fontSize: '11px', 
      color: '#faad14', 
      display: 'inline-flex', 
      alignItems: 'center',
      verticalAlign: 'middle',
      fontWeight: 'normal',
      background: '#fffbe6',
      padding: '2px 6px',
      borderRadius: '4px',
      border: '1px solid #ffe58f'
    }}>
      <StarFilled style={{ marginRight: '4px' }} />
      Expert Support
    </span>
  )}
</Title>

                      

                      {/* 2. Author Information */}
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: '12px' }}>
                        <Avatar size="small" icon={<UserOutlined />} />
                        {authorName ? (
                          <Popover
                            content={
                              <div style={{ padding: '4px' }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <Text style={{ fontSize: "16px" }}>{authorName}</Text>
                                  {linkedInUrl && (
                                    <a
                                      href={linkedInUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                        width: '24px', height: '24px', borderRadius: '4px',
                                        backgroundColor: '#0077B5', color: 'white'
                                      }}
                                    >
                                      <LinkedinOutlined style={{ fontSize: '14px' }} />
                                    </a>
                                  )}
                                </div>
                              </div>
                            }
                            title="Author Information"
                            trigger="click"
                          >
                            <Text
                              type="secondary"
                              style={{ fontSize: "13px", cursor: "pointer", textDecoration: "underline", textDecorationStyle: "dotted" }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {authorName}
                            </Text>
                          </Popover>
                        ) : (
                          <Text type="secondary" style={{ fontSize: "13px" }}>No author available</Text>
                        )}
                      </div>

                      {/* 3. Stats Row */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <ClockCircleOutlined style={{ color: "#666", fontSize: "14px" }} />
                          <Text type="secondary" style={{ fontSize: "14px" }}>
                            {formatTime(course.estimatedTime)}
                          </Text>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <BookOutlined style={{ color: "#666", fontSize: "14px" }} />
                          <Text type="secondary" style={{ fontSize: "14px" }}>
                            {course.moduleCount} Modules
                          </Text>
                        </div>
                      </div>

                      {/* 4. Description Section (Fills Space) */}
                      <div style={{ flex: 1, marginBottom: '12px' }}>
                        {course.description && (
                          <>
                            <Text strong style={{ fontSize: "14px", marginBottom: '4px', display: 'block' }}>
                              Description
                            </Text>
                            <div style={{
                              fontSize: '14px',
                              color: '#666',
                              display: "-webkit-box",
                              WebkitLineClamp: expandedCourseId === course.id ? "unset" : 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden"
                            }}>
                              {course.description}
                            </div>
                            {course.description.length > 70 && (
                              <Button
                                type="link"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleDescription(course.id, e);
                                }}
                                style={{ padding: '0', height: 'auto', fontSize: '12px' }}
                              >
                                {expandedCourseId === course.id ? "See less" : "See more"}
                              </Button>
                            )}
                          </>
                        )}
                      </div>

                      {/* 5. Action Button */}
                      <Button
                        type="primary"
                        loading={localEnrollingId === course.id || enrollingId === course.id}
                        onClick={(e) => handleEnroll(course, e)}
                        block
                        icon={<StarOutlined />}
                        disabled={isBlocked}
                      >
                        {course.isPaid ? "Buy Now" : "Enroll Now"}
                      </Button>

                    </Card>


                  );
                })}

                {/* Pagination for Available Courses */}
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                  <Pagination
                    current={availablePagination.currentPage}
                    pageSize={availablePagination.pageSize}
                    total={availablePagination.totalCount}
                    onChange={handleAvailablePaginationChange}
                    onShowSizeChange={handleAvailablePaginationChange}
                    showSizeChanger
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} courses`
                    }
                    pageSizeOptions={['6', '9', '12', '18', '24']}
                  />
                </div>
              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <StarOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
                <Title level={4} style={{ color: '#666' }}>
                  No Available Courses
                </Title>
                <Text style={{ color: '#666' }}>
                  You are already enrolled in all available courses.
                </Text>
              </div>
            )}
          </TabPane>

          {/* Enrolled Courses Tab */}
          <TabPane
            tab={
              <span>
                <BookOutlined />
                Enrolled Courses
                {enrolledPagination.totalCount > 0 && (
                  <span style={{
                    marginLeft: '8px',
                    backgroundColor: '#52c41a',
                    color: 'white',
                    borderRadius: '10px',
                    padding: '2px 8px',
                    fontSize: '12px'
                  }}>
                    {enrolledPagination.totalCount}
                  </span>
                )}
              </span>
            }
            key="enrolled"
          >
            {enrollments.length > 0 ? (
              <>
                {enrollments.map((enrollment) => {
                  const progressPercentage = calculateProgress(enrollment);
                  const linkedInUrl = getLinkedInUrl(enrollment.course);
                  const authorName = getAuthorName(enrollment.course);

                  return (
                    <Card
                      key={enrollment.id}
                      style={{
                        width: '100%',
                        marginBottom: '16px',
                        border: '3px solid #cdd6e2ff',
                        borderTop: 'none',
                        borderRadius: '0px',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                        cursor: isBlocked ? 'not-allowed' : 'pointer',
                        position: 'relative', // Essential for the absolute ribbon
                        overflow: 'hidden',   // Clips the ribbon edges
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                      hoverable={!isBlocked}
                      onClick={() => !isBlocked && handleViewEnrolledCourse(enrollment.id)}
                      bodyStyle={{
                        padding: '14px',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1
                      }}
                    >
                      {/* --- CORNER RIBBON BANNER --- */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          openPriceModal && openPriceModal(e, enrollment);
                        }}
                        style={{
                          position: "absolute",
                          // Adjusted offsets for a larger ribbon
                          top: 22,
                          right: -45,
                          background: enrollment.course.isPaid ? "#13c2c2" : "#52c41a",
                          color: "white",
                        
                          padding: "6px 0",
                          transform: "rotate(45deg)",
                          fontSize: "13px", 
                          fontWeight: "bold",
                          zIndex: 10,
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          textAlign: "center",
                          
                          width: "160px",
                          cursor: "pointer",
                          lineHeight: "1"
                        }}
                      >
                        {enrollment.course.isPaid ? (
                          `${enrollment.course.pricing?.currency === "USD" ? "$" : enrollment.course.pricing?.currency}${enrollment.course.pricing?.price || 0}`
                        ) : (
                          "FREE"
                        )}
                      </div>

<Title
  level={4}
  style={{
    margin: 0,
    marginBottom: '12px',
    lineHeight: "1.3",
    paddingRight: '40px', // Prevents title from going under the ribbon
    minHeight: '44px',
    fontSize: '16px'
  }}
>
  {enrollment.course.title}
  
  {/* INLINE STAR + TEXT - Expert Support Tag */}
  {enrollment.course.hasActiveExpertSupport && (
    <span style={{ 
      marginLeft: '8px', 
      fontSize: '11px', 
      color: '#faad14', 
      display: 'inline-flex', 
      alignItems: 'center',
      verticalAlign: 'middle',
      fontWeight: 'normal',
      background: '#fffbe6',
      padding: '2px 6px',
      borderRadius: '4px',
      border: '1px solid #ffe58f'
    }}>
      <StarFilled style={{ marginRight: '4px' }} />
      Expert Support
    </span>
  )}
</Title>

                      {/* 2. Author Information */}
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: '12px' }}>
                        <Avatar size="small" icon={<UserOutlined />} />
                        {authorName ? (
                          <Popover
                            content={
                              <div style={{ padding: '4px' }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <Text style={{ fontSize: "16px" }}>{authorName}</Text>
                                  {linkedInUrl && (
                                    <a
                                      href={linkedInUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                        width: '24px', height: '24px', borderRadius: '4px',
                                        backgroundColor: '#0077B5', color: 'white'
                                      }}
                                    >
                                      <LinkedinOutlined style={{ fontSize: '14px' }} />
                                    </a>
                                  )}
                                </div>
                              </div>
                            }
                            title="Author Information"
                            trigger="click"
                          >
                            <Text
                              type="secondary"
                              style={{ fontSize: "13px", cursor: "pointer", textDecoration: "underline", textDecorationStyle: "dotted" }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {authorName}
                            </Text>
                          </Popover>
                        ) : (
                          <Text type="secondary" style={{ fontSize: "13px" }}>No author available</Text>
                        )}
                      </div>

                      {/* 3. Stats Row */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <ClockCircleOutlined style={{ color: "#666", fontSize: "14px" }} />
                          <Text type="secondary" style={{ fontSize: "14px" }}>
                            {formatTime(enrollment.course.estimatedTime)}
                          </Text>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <BookOutlined style={{ color: "#666", fontSize: "14px" }} />
                          <Text type="secondary" style={{ fontSize: "14px" }}>
                            {enrollment.course.moduleCount} Modules
                          </Text>
                        </div>
                      </div>

                      {/* 4. Description Section (Fills Space) */}
                      <div style={{ flex: 1, marginBottom: '12px' }}>
                        {enrollment.course.description && (
                          <>
                            <Text strong style={{ fontSize: "14px", marginBottom: '4px', display: 'block' }}>
                              Description
                            </Text>
                            <div style={{
                              fontSize: '14px',
                              color: '#666',
                              display: "-webkit-box",
                              WebkitLineClamp: expandedCourseId === enrollment.id ? "unset" : 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden"
                            }}>
                              {enrollment.course.description}
                            </div>
                            {enrollment.course.description.length > 70 && (
                              <Button
                                type="link"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleDescription(enrollment.id, e);
                                }}
                                style={{ padding: '0', height: 'auto', fontSize: '12px' }}
                              >
                                {expandedCourseId === enrollment.id ? "See less" : "See more"}
                              </Button>
                            )}
                          </>
                        )}
                      </div>

                      {/* 5. Action Button */}
                      <Button
                        type="primary"
                        block
                        icon={<PlayCircleOutlined />}
                        loading={startingCourse === enrollment.id}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleContinueLearning(enrollment.id);
                        }}
                        disabled={isBlocked}
                      >
                        Continue Learning
                      </Button>

                    </Card>
                  );
                })}

                {/* Pagination for Enrolled Courses */}
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                  <Pagination
                    current={enrolledPagination.currentPage}
                    pageSize={enrolledPagination.pageSize}
                    total={enrolledPagination.totalCount}
                    onChange={handleEnrolledPaginationChange}
                    onShowSizeChange={handleEnrolledPaginationChange}
                    showSizeChanger
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} courses`
                    }
                    pageSizeOptions={['6', '9', '12', '18', '24']}
                  />
                </div>
              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <BookOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
                <Title level={4} style={{ color: '#666' }}>
                  No Enrolled Courses
                </Title>
                <Text style={{ color: '#666' }}>
                  You have not enrolled in any courses yet.
                </Text>
                <Button
                  type="primary"
                  style={{
                    marginTop: '16px',
                  }}
                  onClick={() => setActiveTab('available')}
                  icon={<StarOutlined />}
                  disabled={isBlocked}
                >
                  Browse Available Courses
                </Button>
              </div>
            )}
          </TabPane>
        </Tabs>
      </div>

    
{/* EXPERT SUPPORT MODAL */}
<Modal
  title="Expert Support Available"
  open={isExpertSupportModalVisible}
  onCancel={() => setIsExpertSupportModalVisible(false)}
  footer={[
    <Button key="cancel" onClick={() => setIsExpertSupportModalVisible(false)}>
      Cancel
    </Button>,
   <Button
  key="purchase"
  type="primary"
  onClick={() => {
    const supportRequired =
      selectedCourseForPurchase.courseExpertSupport.recommendationLevel ===
      ExpertRecommendationLevelEnum.Required;
      
    const finalIncludeSupport = supportRequired
      ? true
      : includeExpertSupport === true;

    setIsExpertSupportModalVisible(false);
    proceedWithPurchase(selectedCourseForPurchase.id, finalIncludeSupport);
  }}
>

      Proceed to Purchase
    </Button>
  ]}
  width={600}
>
  {selectedCourseForPurchase && (
    <div>
      <Title level={4}>{selectedCourseForPurchase.title}</Title>
      
      <Descriptions bordered column={1} size="small" style={{ marginBottom: 16 }}>
        <Descriptions.Item label="Course Price">
          <Text strong style={{ fontSize: '16px' }}>
            {selectedCourseForPurchase.pricing?.currency} {selectedCourseForPurchase.pricing?.price}
          </Text>
        </Descriptions.Item>
        
        <Descriptions.Item label="Access Duration">
          {formatDuration(selectedCourseForPurchase.pricing?.accessDurationDays)}
        </Descriptions.Item>
      </Descriptions>

      
      <div style={{ 
        padding: '16px', 
        backgroundColor: '#f0f9ff', 
        borderRadius: '8px',
        marginBottom: '16px'
      }}>
        <Title level={5} style={{ marginBottom: '8px' }}>
          <TeamOutlined /> Expert Support Service
        </Title>
        
        <div style={{ marginBottom: '12px' }}>
          <Avatar 
            src={selectedCourseForPurchase.courseExpertSupport.expert?.profileImage}
            icon={<UserOutlined />}
            size="small"
            style={{ marginRight: '8px' }}
          />
          <Text strong>
            {selectedCourseForPurchase.courseExpertSupport.expert?.firstName} {selectedCourseForPurchase.courseExpertSupport.expert?.lastName}
          </Text>
        </div>
        
        <Text type="secondary">
          {selectedCourseForPurchase.courseExpertSupport.description}
        </Text>
        
      <div style={{ marginTop: '8px' }}>
 <Text strong>
  ${selectedCourseForPurchase.courseExpertSupport.unitPrice}/
  {formatMinutesToHours(
    selectedCourseForPurchase.courseExpertSupport.unitDurationMinutes
  )}
</Text>
</div>
      </div>
      
      <div style={{ marginBottom: '16px' }}>
        <Text strong>Recommendation: </Text>
        <Tag color={
          selectedCourseForPurchase.courseExpertSupport.recommendationLevel === ExpertRecommendationLevelEnum.Required ? 'red' :
          selectedCourseForPurchase.courseExpertSupport.recommendationLevel === ExpertRecommendationLevelEnum.StronglyRecommended ? 'orange' :
          selectedCourseForPurchase.courseExpertSupport.recommendationLevel === ExpertRecommendationLevelEnum.Recommended ? 'blue' : 'default'
        }>
          {ExpertRecommendationLevelEnumLabels[selectedCourseForPurchase.courseExpertSupport.recommendationLevel]}
        </Tag>
      </div>
      
      {selectedCourseForPurchase.courseExpertSupport.recommendationLevel !== ExpertRecommendationLevelEnum.Required && (
        <div style={{ marginBottom: '16px' }}>
          <Text>Would you like to include expert support with your purchase?</Text>
        </div>
      )}
      
     {selectedCourseForPurchase.courseExpertSupport.recommendationLevel !== ExpertRecommendationLevelEnum.Required && (
  <div style={{ marginBottom: '16px' }}>
    <Text>Would you like to include expert support with your purchase?</Text>
  </div>
)}

<Radio.Group
  value={includeExpertSupport}
  onChange={(e) => setIncludeExpertSupport(Boolean(e.target.value))}
>
  <Space direction="vertical">
    <Radio 
      value={false} 
      disabled={selectedCourseForPurchase.courseExpertSupport.recommendationLevel === ExpertRecommendationLevelEnum.Required}
    >
      <div>
        <Text>Course Only</Text>
        <div style={{ fontSize: '12px', color: '#666' }}>
          {selectedCourseForPurchase.pricing?.currency} {selectedCourseForPurchase.pricing?.price}
        </div>
      </div>
    </Radio>
   <Radio value={true}>
  <div>
    <Text>Course + Expert Support</Text>
    <div style={{ fontSize: '12px', color: '#666' }}>
      {selectedCourseForPurchase.pricing?.currency} {selectedCourseForPurchase.pricing?.price} + 
      ${selectedCourseForPurchase.courseExpertSupport.unitPrice} × 
      {selectedCourseForPurchase.courseExpertSupport.allowedUnits} units = 
      <Text strong> {selectedCourseForPurchase.pricing?.currency} {
        Number(selectedCourseForPurchase.pricing?.price) + 
        (Number(selectedCourseForPurchase.courseExpertSupport.unitPrice) * 
         Number(selectedCourseForPurchase.courseExpertSupport.allowedUnits))
      }</Text>
    </div>
    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
      Includes {selectedCourseForPurchase.courseExpertSupport.allowedUnits} sessions of  <strong>
      {formatMinutesToHours(selectedCourseForPurchase.courseExpertSupport.unitDurationMinutes)} </strong>each
    </div>
  </div>
</Radio>
  </Space>
</Radio.Group>

{selectedCourseForPurchase.courseExpertSupport.recommendationLevel === ExpertRecommendationLevelEnum.Required && (
  <div style={{ marginTop: '8px', fontSize: '12px', color: '#ff4d4f' }}>
    Expert support is required for this course.
  </div>
)}
    </div>
  )}
</Modal>
      {/* PRICE DETAIL MODAL */}
      <Modal
        title="Pricing & Access Information"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[<Button key="close" type="primary" onClick={() => setIsModalVisible(false)}>Got it</Button>]}
      >
        {selectedPriceData && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Price">
              <Text strong type="success" style={{ fontSize: '16px' }}>
                {selectedPriceData.pricing?.currency} {selectedPriceData.pricing?.price}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="Access Duration">
              {formatDuration(selectedPriceData.pricing?.accessDurationDays)}
            </Descriptions.Item>

          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default AvailableCourses;